import { CONFIG_UPDATE } from './types';
const initialState = {
  adultAges: {},
  countries: [],
  documents: {
    hipaadoc: {},
    pnpat: {},
    privacypolicy: {},
    toufsll: {},
    toupat: {},
    hipaa: {}
  },
  documentsUrl: '',
  languages: [],
  libreSharingApiUrl: '',
  partners: {},
  sharingWebviewsUrl: '',
  supportedCountries: [],
  validation: {
    identity: [],
    libreSharingApi: {
      patient: {
        firstName: {
          stringMaxLength: 0
        },
        lastName: {
          stringMaxLength: 0
        }
      }
    }
  },
  webviewsUrl: '',
  lvapiURL: '',
  libreApiCountryUrls: {},
  libreSharingApiCountryUrls: {},
  lvApiCountryUrls: {},
  zipCodePatterns: {},
  regions: {}
};
export const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIG_UPDATE:
      return {
        ...state,
        ...action.config
      };
    default:
      return state;
  }
};